import { render, staticRenderFns } from "./TabWhatsapp.vue?vue&type=template&id=462b8485&scoped=true"
import script from "./TabWhatsapp.vue?vue&type=script&lang=js"
export * from "./TabWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./TabWhatsapp.vue?vue&type=style&index=0&id=462b8485&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b8485",
  null
  
)

export default component.exports